import { IAbsenceRequest } from '../Client/IAbsenceRequest'
import {IAbsenceRequestStatistics} from '../Client/IAbsenceRequestStatistics'

export const GET_ABSENCE_REQUESTS_REQUEST = 'GET_ABSENCE_REQUESTS_REQUEST'
export const GET_ABSENCE_REQUESTS_SUCCESS = 'GET_ABSENCE_REQUESTS_SUCCESS'
export const GET_ABSENCE_REQUESTS_FAILURE = 'GET_ABSENCE_REQUESTS_FAILURE'

export const CREATE_ABSENCE_REQUEST_REQUEST = 'CREATE_ABSENCE_REQUEST_REQUEST'
export const CREATE_ABSENCE_REQUEST_SUCCESS = 'CREATE_ABSENCE_REQUEST_SUCCESS'
export const CREATE_ABSENCE_REQUEST_FAILURE = 'CREATE_ABSENCE_REQUEST_FAILURE'

export const DELETE_ABSENCE_REQUEST_REQUEST = 'DELETE_ABSENCE_REQUEST_REQUEST'
export const DELETE_ABSENCE_REQUEST_SUCCESS = 'DELETE_ABSENCE_REQUEST_SUCCESS'
export const DELETE_ABSENCE_REQUEST_FAILURE = 'DELETE_ABSENCE_REQUEST_FAILURE'

export const UPDATE_ABSENCE_REQUEST_REQUEST = 'UPDATE_ABSENCE_REQUEST_REQUEST'
export const UPDATE_ABSENCE_REQUEST_SUCCESS = 'UPDATE_ABSENCE_REQUEST_SUCCESS'
export const UPDATE_ABSENCE_REQUEST_FAILURE = 'UPDATE_ABSENCE_REQUEST_FAILURE'

export const APPROVE_ABSENCE_REQUEST_REQUEST = 'APPROVE_ABSENCE_REQUEST_REQUEST'
export const APPROVE_ABSENCE_REQUEST_SUCCESS = 'APPROVE_ABSENCE_REQUEST_SUCCESS'
export const APPROVE_ABSENCE_REQUEST_FAILURE = 'APPROVE_ABSENCE_REQUEST_FAILURE'

export const DECLINE_ABSENCE_REQUEST_REQUEST = 'DECLINE_ABSENCE_REQUEST_REQUEST'
export const DECLINE_ABSENCE_REQUEST_SUCCESS = 'DECLINE_ABSENCE_REQUEST_SUCCESS'
export const DECLINE_ABSENCE_REQUEST_FAILURE = 'DECLINE_ABSENCE_REQUEST_FAILURE'

export const GET_ABSENCE_STATISTICS_REQUEST = 'GET_ABSENCE_STATISTICS_REQUEST'
export const GET_ABSENCE_STATISTICS_SUCCESS = 'GET_ABSENCE_STATISTICS_SUCCESS'
export const GET_ABSENCE_STATISTICS_FAILURE = 'GET_ABSENCE_STATISTICS_FAILURE'

interface GetAbsenceRequestsAction {
    type: typeof GET_ABSENCE_REQUESTS_REQUEST
}

interface GetAbsenceRequestsSuccess {
    type: typeof GET_ABSENCE_REQUESTS_SUCCESS
    payload: {
        absenceRequests: IAbsenceRequest[]
    }
}

interface GetAbsenceRequestsFailure {
    type: typeof GET_ABSENCE_REQUESTS_FAILURE
}

interface CreateAbsenceRequestAction {
    type: typeof CREATE_ABSENCE_REQUEST_REQUEST
}

interface CreateAbsenceRequestSuccess {
    type: typeof CREATE_ABSENCE_REQUEST_SUCCESS
    payload: {
        absenceRequest: IAbsenceRequest
    }
}

interface CreateAbsenceRequestFailure {
    type: typeof CREATE_ABSENCE_REQUEST_FAILURE
    payload: {
        error: string
    }
}

interface DeleteAbsenceRequestAction {
    type: typeof DELETE_ABSENCE_REQUEST_REQUEST
}

interface DeleteAbsenceRequestSuccess {
    type: typeof DELETE_ABSENCE_REQUEST_SUCCESS
    payload: {
        absenceRequest: IAbsenceRequest
    }
}

interface DeleteAbsenceRequestFailure {
    type: typeof DELETE_ABSENCE_REQUEST_FAILURE
    errors: any
}

interface UpdateAbsenceRequestAction {
    type: typeof UPDATE_ABSENCE_REQUEST_REQUEST
}

interface UpdateAbsenceRequestSuccess {
    type: typeof UPDATE_ABSENCE_REQUEST_SUCCESS
    payload: {
        absenceRequest: IAbsenceRequest
    }
}

interface UpdateAbsenceRequestFailure {
    type: typeof UPDATE_ABSENCE_REQUEST_FAILURE
}

interface ApproveAbsenceRequestAction {
    type: typeof APPROVE_ABSENCE_REQUEST_REQUEST
}

interface ApproveAbsenceRequestSuccess {
    type: typeof APPROVE_ABSENCE_REQUEST_SUCCESS
    payload: {
        absenceRequest: IAbsenceRequest
    }
}

interface ApproveAbsenceRequestFailure {
    type: typeof APPROVE_ABSENCE_REQUEST_FAILURE
        payload: {
        error: string
    }
}
interface DeclineAbsenceRequestAction {
    type: typeof DECLINE_ABSENCE_REQUEST_REQUEST
}

interface DeclineAbsenceRequestSuccess {
    type: typeof DECLINE_ABSENCE_REQUEST_SUCCESS
    payload: {
        absenceRequest: IAbsenceRequest
    }
}

interface DeclineAbsenceRequestFailure {
    type: typeof DECLINE_ABSENCE_REQUEST_FAILURE
}

interface GetAbsenceStatisticsAction {
    type: typeof GET_ABSENCE_STATISTICS_REQUEST
}

interface GetAbsenceStatisticsSuccess {
    type: typeof GET_ABSENCE_STATISTICS_SUCCESS
    payload: {
        statistics: IAbsenceRequestStatistics[]
    }
}

interface GetAbsenceStatisticsFailure {
    type: typeof GET_ABSENCE_STATISTICS_FAILURE
}

export type ActionTypes =
    | GetAbsenceRequestsAction
    | GetAbsenceRequestsSuccess
    | GetAbsenceRequestsFailure
    | CreateAbsenceRequestAction
    | CreateAbsenceRequestSuccess
    | CreateAbsenceRequestFailure
    | DeleteAbsenceRequestAction
    | DeleteAbsenceRequestSuccess
    | DeleteAbsenceRequestFailure
    | UpdateAbsenceRequestAction
    | UpdateAbsenceRequestSuccess
    | UpdateAbsenceRequestFailure
    | ApproveAbsenceRequestAction
    | ApproveAbsenceRequestSuccess
    | ApproveAbsenceRequestFailure
    | DeclineAbsenceRequestAction
    | DeclineAbsenceRequestSuccess
    | DeclineAbsenceRequestFailure
    | GetAbsenceStatisticsAction
    | GetAbsenceStatisticsSuccess
    | GetAbsenceStatisticsFailure
